import { UserAssign } from "@app/shared/components/UserAssign";
import { FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { FC } from "react";
import { useGenerateAiSuggestions, useUpdateEsrs } from "../../data";
import { PillarEsrs } from "../../types";
import { Button } from "@design-system/Inputs/Button";
import { useSetToast } from "@app/components/Toast";
import { RESOURCE_NAME, keys } from "../../i18n.ts";
import { useTranslation } from "react-i18next";

export const SectionHeader: FC<{ esrs: PillarEsrs }> = ({ esrs }) => {
    const { t } = useTranslation(RESOURCE_NAME);
    const users = esrs.ownerIds ?? [];
    const { mutate: handleSelect } = useUpdateEsrs(esrs.cmsId);
    const { mutate: generateAiSuggestions } = useGenerateAiSuggestions();
    const { setToastSuccess } = useSetToast();

    const handleSuggestAll = () => {
        generateAiSuggestions(esrs.cmsId, {
            onSuccess: () => {
                setToastSuccess(t(keys.suggest_all_success));
            },
        });
    };

    return (
        <FlexRow
            className="border-t-4 border-t-beavrGreen bg-tertiary h-[84px] box-border"
            p="4"
            id={esrs?.cmsId}
            justifyContent="between"
        >
            <Text variant="hero6">{esrs?.name}</Text>

            <FlexRow className="gap-3">
                {!!esrs?.disclosureRequirements.flatMap((dr) => dr?.datapoints)
                    ?.length && (
                    <UserAssign
                        enableNone
                        selectedUsers={users}
                        onSelect={handleSelect}
                        selectMode="single"
                    />
                )}
                <Button
                    variant="flatAccent"
                    onClick={handleSuggestAll}
                    size="sm"
                >
                    <Text variant="body-bold" color="white">
                        {t(keys.suggest_all)}
                    </Text>
                    <Button.Icon name="stars" />
                </Button>
            </FlexRow>
        </FlexRow>
    );
};
